import { render, staticRenderFns } from "./setting-layout-prize.vue?vue&type=template&id=990a06aa&scoped=true"
import script from "./setting-layout-prize.vue?vue&type=script&lang=js"
export * from "./setting-layout-prize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990a06aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('990a06aa')) {
      api.createRecord('990a06aa', component.options)
    } else {
      api.reload('990a06aa', component.options)
    }
    module.hot.accept("./setting-layout-prize.vue?vue&type=template&id=990a06aa&scoped=true", function () {
      api.rerender('990a06aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/form-b/setting-layout-prize.vue"
export default component.exports